<template>
  <div>
    <record-info
      class="mb-100"
      :record="record"
      :status="status"
      is-large
    ></record-info>

    <record-status-selector
      :record="record"
    ></record-status-selector>
  </div>
</template>

<script>
export default {
  name: "LeadBoxNonLead",
  props: {
    record: {
      type: Object,
      required: true
    },
    status: {
      type: Object,
      required: true
    }
  },
};
</script>
